/**
 * HubSpot Visitor Identity Service
 *
 * Identifies authenticated users to the HubSpot chat widget using the
 * Visitor Identification API. The identification token is generated server-side
 * (HMAC-SHA256 of the user's email) to keep the secret out of the client.
 *
 * @see https://developers.hubspot.com/docs/api/conversation/chat-widget-sdk
 * @see https://developers.hubspot.com/docs/api/conversation/visitor-identification
 */
const HubspotIdentityService = {
  /**
   * Identify the current user to the HubSpot chat widget.
   * Sets hsConversationsSettings before widget initialization, and calls
   * widget.load() to initialize the widget with the visitor's identity.
   *
   * @param {string} email - The authenticated user's email address
   * @param {string} token - HMAC-SHA256 token generated by the backend
   */
  identify (email, token) {
    window.hsConversationsSettings = window.hsConversationsSettings || {}
    window.hsConversationsSettings.identificationEmail = email
    window.hsConversationsSettings.identificationToken = token

    // Load the widget now that identity is set. Use hsConversationsOnReady as a
    // fallback for when the token arrives before HubSpot's API object is ready.
    if (window.HubSpotConversations) {
      window.HubSpotConversations.widget.load()
    } else {
      window.hsConversationsOnReady = window.hsConversationsOnReady || []
      window.hsConversationsOnReady.push(() => {
        window.HubSpotConversations.widget.load()
      })
    }
  },

  /**
   * Reset the HubSpot chat widget identity on logout.
   * Removes the widget from the DOM; it will reload without identity on next login.
   */
  reset () {
    window.hsConversationsSettings = window.hsConversationsSettings || {}
    delete window.hsConversationsSettings.identificationEmail
    delete window.hsConversationsSettings.identificationToken

    if (window.HubSpotConversations) {
      window.HubSpotConversations.widget.remove()
    }
  }
}

export default HubspotIdentityService
